import * as Sentry from '@sentry/nextjs';

import { CACHE_REPORT_TO_SENTRY } from '../config';

export const wrapInSentrySpan = <T>(
  name: string,
  op: (_span: Sentry.Span | undefined) => T,
): T => {
  if (!CACHE_REPORT_TO_SENTRY) {
    return op(undefined);
  }

  return Sentry.startSpan({ name }, span => {
    return op(span);
  });
};
